module.exports = __webpack_public_path__ + "img/recommed-img8.f9bbd8ae.jpg";